import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
// Singleton
export var HTMLToCustomTextConverter = /*#__PURE__*/function () {
  function HTMLToCustomTextConverter() {
    _classCallCheck(this, HTMLToCustomTextConverter);

    _defineProperty(this, "tagReplacements", new Map());
  }

  _createClass(HTMLToCustomTextConverter, [{
    key: "withTransformTag",
    value: function withTransformTag(tagName, replacementText) {
      if (!tagName || !replacementText) {
        throw new Error('Tag name and replacement text are required');
      }

      this.tagReplacements.set(tagName.toLowerCase(), replacementText);
      return this;
    }
  }, {
    key: "convert",
    value: function convert(htmlContent) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!htmlContent) {
        return '';
      }

      var _options$removeOtherT = options.removeOtherTags,
          removeOtherTags = _options$removeOtherT === void 0 ? true : _options$removeOtherT,
          _options$decodeHtmlEn = options.decodeHtmlEntities,
          decodeHtmlEntities = _options$decodeHtmlEn === void 0 ? true : _options$decodeHtmlEn,
          _options$trimResult = options.trimResult,
          trimResult = _options$trimResult === void 0 ? true : _options$trimResult;
      var result = htmlContent;
      this.tagReplacements.forEach(function (replacementText, tagName) {
        // 1. Match paired tags with content or empty content: <tag ...>...</tag>
        // This handles:
        // - <tag>content</tag>
        // - <tag></tag>
        // - Tags with attributes: <tag class="x">...</tag>
        var pairedTagRegex = new RegExp("<".concat(tagName, "(?:\\s+[^>]*)?>[\\s\\S]*?<\\/").concat(tagName, ">"), 'gi');
        result = result.replace(pairedTagRegex, replacementText); // 2. Match self-closing tags: <tag ... />
        // This handles:
        // - <tag />
        // - <tag class="x" />

        var selfClosingRegex = new RegExp("<".concat(tagName, "\\b[^>]*\\/>"), 'gi');
        result = result.replace(selfClosingRegex, replacementText); // 3. Match opening tags (standalone): <tag ...>
        // This handles cases where only the opening tag exists or it's a void tag being treated significantly
        // - <tag>
        // - <tag class="x">

        var openingTagRegex = new RegExp("<".concat(tagName, "\\b(?:\\s+[^>]*)?>"), 'gi');
        result = result.replace(openingTagRegex, replacementText);
      }); // Remove other HTML tags if requested

      if (removeOtherTags) {
        // Remove any remaining HTML tags
        result = result.replace(/<[^>]*>/g, '');
      } // Decode HTML entities if requested


      if (decodeHtmlEntities) {
        result = this.decodeHtmlEntities(result);
      } // Trim result if requested


      if (trimResult) {
        result = result.trim();
      }

      return result;
    }
  }, {
    key: "decodeHtmlEntities",
    value: function decodeHtmlEntities(text) {
      var entityMap = {
        '&nbsp;': ' ',
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&apos;': "'"
      };
      var decoded = text;
      Object.entries(entityMap).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            entity = _ref2[0],
            _char = _ref2[1];

        decoded = decoded.replace(new RegExp(entity, 'g'), _char);
      });
      return decoded;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!HTMLToCustomTextConverter.instance) {
        HTMLToCustomTextConverter.instance = new HTMLToCustomTextConverter();
      }

      return HTMLToCustomTextConverter.instance;
    }
  }, {
    key: "resetInstance",
    value: function resetInstance() {
      HTMLToCustomTextConverter.instance = null;
    }
  }]);

  return HTMLToCustomTextConverter;
}();

_defineProperty(HTMLToCustomTextConverter, "instance", null);